import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from '../../../../node_modules/rxjs';
import { take, map } from '../../../../node_modules/rxjs/operators';
import { PostsService } from '../data/posts.service';

@Injectable()
export class PostResolver implements Resolve<Observable<any>> {

    constructor(private postsService: PostsService) { }

    resolve(route: ActivatedRouteSnapshot) {
        const uid = route.paramMap.get('uid');
        return this.postsService
            .getPost(uid)
            .pipe(
                take(1),
                map((res) => res.result),
            );
    }

}
